<template>
    <div class="com-item lightBanner-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{ backgroundColor: W.bgColor || 'transparent' }">
                <div
                    v-if="W.bgImg"
                    class="lightBanner-module__bg"
                    :style="{ backgroundImage: 'url(' + W.bgImg + ')' }"
                >
                    <img class="bgImg" :src="W.bgImg" alt="">
                    <div class="lightBanner-module__inner">
                        <h2 class="lightBanner-module__cn">{{ W.cnTitle }}</h2>
                        <p class="lightBanner-module__sub">{{ W.subtitle }}</p>
                        <div class="lightBanner-module__desc" v-html="W.describeHtml"></div>

                        <ul v-if="W.tags && W.tags.length" class="lightBanner-module__tags">
                            <li v-for="(t, i) in W.tags" :key="'t' + i" class="lightBanner-module__tag">
                                <img v-if="t.iconUrl" :src="t.iconUrl" class="lightBanner-module__tag-icon" alt="" />
                                <p class="lightBanner-module__tag-title">{{ t.title }}</p>
                                <p class="lightBanner-module__tag-sub">{{ t.subTitle }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'lightBanner-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'lightBanner',
                    Title: '以光引领',
                    MID: 38,
                    ModuleName: 'lightBannerModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            defaultData: {
                cnTitle: '以光引领 照亮未来',
                subtitle: '24 年研制销一体车灯工厂',
                describeHtml: '<p>AES 专注汽车照明领域的研发与创新，构建了从光学设计、仿真分析、精密制造到品质检测的全链路技术体系，为全球客户提供更安全、更智能的照明解决方案。</p>',
                tags: [
                    { iconUrl: "", title: '专注专业', subTitle: '23年行业深耕' },
                    { iconUrl: "", title: '创新驱动', subTitle: '1000+核心专利' },
                    { iconUrl: "", title: '品质为先', subTitle: '严苛质量管理' },
                    { iconUrl: "", title: '全球服务', subTitle: '110+国家覆盖' }
                ],
                bgImg: ""
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.tags) || !this.modata.WContent.tags.length) {
            this.$set(this.modata.WContent, 'tags', JSON.parse(JSON.stringify(this.defaultData.tags)))
        }
    },
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.lightBanner-module {
    margin-bottom: 30px;

    .lightBanner-module__bg {
        position: relative;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        min-height: 120px;
        padding: 80px 0;
        max-width: 1600px;
        margin: auto;

        .bgImg{
            width: 100%;
            height: auto;
            display: none;
        }

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 0.55) 50%, rgba(0, 0, 0, 0) 100%);
            pointer-events: none;
        }
    }

    .lightBanner-module__inner {
        position: relative;
        z-index: 2;
        width: 96%;
        max-width: 500px;
        margin: 0 0 0 5%;
        box-sizing: border-box;
        color: #000;
    }

    .lightBanner-module__cn {
        font-size: 36px;
        font-weight: bold;
        line-height: 1.3;
        margin: 0 0 12px;
        color: #d81e06;
    }

    .lightBanner-module__sub {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.4;
        margin: 0 0 24px;
    }

    .lightBanner-module__desc {
        font-size: 14px;
        line-height: 1.8;
        margin: 0 0 40px;
        max-width: 600px;

        ::v-deep p {
            margin: 0 0 12px;
        }
    }

    .lightBanner-module__tags {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 32px;
        max-width: 900px;
    }

    .lightBanner-module__tag {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .lightBanner-module__tag-icon {
        width: 34px;
        height: 34px;
        margin-bottom: 8px;
    }

    .lightBanner-module__tag-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.4;
        margin: 0 0 4px;
    }

    .lightBanner-module__tag-sub {
        font-size: 12px;
        line-height: 1.4;
        margin: 0;
        color: #888;
    }
}

@media screen and (max-width: 768px) {
    .lightBanner-module {

        .lightBanner-module__bg {
            min-height: 420px;
            padding: 0 0 20px;
            background-image: none !important;
            .bgImg{
                display: block;
                margin-bottom: 20px;
            }
            &::before {
                display: none;
             }
        }

        .lightBanner-module__cn {
            font-size: 28px;
             margin-bottom: 8px;
        }

        .lightBanner-module__sub {
            font-size: 18px;
            margin-bottom: 8px;
        }
        .lightBanner-module__desc{
            margin-bottom: 12px;
            font-size: 18px;
        }

        .lightBanner-module__tags {
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
        }
        .lightBanner-module__tag-sub{
            font-size: 15px;
      
        }
    }
}
</style>